/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsRequest interface.
 */
export function instanceOfFxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsRequest(value) {
    if (!('GameSystemName' in value) || value['GameSystemName'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsRequestFromJSON(json) {
    return FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsRequestFromJSONTyped(json, false);
}
export function FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'GameSystemName': json['GameSystemName'],
    };
}
export function FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsRequestToJSON(json) {
    return FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsRequestToJSONTyped(json, false);
}
export function FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'GameSystemName': value['GameSystemName'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsRequest.js.map